import '@angular/compiler';
import { PagePostsComponent } from './page.posts/page.posts.component';
import { PagePopnComponent } from './page.popn/page.popn.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { PageIidxComponent } from './page.iidx/page.iidx.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PageSdvxComponent } from './page.sdvx/page.sdvx.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PageAuthComponent } from './page.auth/page.auth.component';
import { LayoutRhythmComponent } from './layout.rhythm/layout.rhythm.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PagePostsItemComponent } from './page.posts.item/page.posts.item.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { PageTaikoComponent } from './page.taiko/page.taiko.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';

type RhythmMenuId = 'taiko' | 'iidx' | 'popn' | 'sdvx';

const DEFAULT_INDEX_PAGE: RhythmMenuId = 'taiko';
const MENU_ORDER_STORAGE_PREFIX = 'taigo_rhythm_menu_order_v1';
const MENU_ACTIVE_OWNER_STORAGE_KEY = 'taigo_rhythm_menu_active_owner_v1';
const DEFAULT_MENU_ORDER: RhythmMenuId[] = ['taiko', 'iidx', 'popn', 'sdvx'];

const isRhythmMenuId = (value: any): value is RhythmMenuId => value === 'taiko' || value === 'iidx' || value === 'popn' || value === 'sdvx';

const normalizeMenuOrder = (value: any): RhythmMenuId[] => {
    const order: RhythmMenuId[] = [];
    if (Array.isArray(value)) {
        for (const item of value) {
            if (isRhythmMenuId(item) && !order.includes(item)) order.push(item);
        }
    }

    for (const item of DEFAULT_MENU_ORDER) {
        if (!order.includes(item)) order.push(item);
    }
    return order;
};

const getPreferredIndexPage = (): RhythmMenuId => {
    try {
        const owner = localStorage.getItem(MENU_ACTIVE_OWNER_STORAGE_KEY) || 'guest';
        const saved = localStorage.getItem(`${MENU_ORDER_STORAGE_PREFIX}:${owner}`);
        if (!saved) return DEFAULT_INDEX_PAGE;
        return normalizeMenuOrder(JSON.parse(saved))[0] || DEFAULT_INDEX_PAGE;
    } catch {
        return DEFAULT_INDEX_PAGE;
    }
};

const INDEX_PAGE = () => getPreferredIndexPage();

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutSidebarComponent,
        "children": [
            {
                "path": "posts",
                component: PagePostsComponent,
                "app_id": "page.posts"
            },
            {
                "path": "members",
                component: PageMembersComponent,
                "app_id": "page.members"
            },
            {
                "path": "posts/:id/:tab?",
                component: PagePostsItemComponent,
                "app_id": "page.posts.item"
            },
            {
                "path": "dashboard",
                component: PageDashboardComponent,
                "app_id": "page.dashboard"
            }
        ]
    },
    {
        component: LayoutRhythmComponent,
        "children": [
            {
                "path": "popn",
                component: PagePopnComponent,
                "app_id": "page.popn"
            },
            {
                "path": "mypage",
                component: PageMypageComponent,
                "app_id": "page.mypage"
            },
            {
                "path": "iidx/:playStyle?",
                component: PageIidxComponent,
                "app_id": "page.iidx"
            },
            {
                "path": "sdvx/:level?",
                component: PageSdvxComponent,
                "app_id": "page.sdvx"
            },
            {
                "path": "taiko/:level?",
                component: PageTaikoComponent,
                "app_id": "page.taiko"
            }
        ]
    },
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "access",
                component: PageAccessComponent,
                "app_id": "page.access"
            },
            {
                "path": "auth",
                component: PageAuthComponent,
                "app_id": "page.auth"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }
